import React from 'react';
import {
  Modal,
  ModalBody,
  RadioTile,
  TileGroup,
  Tooltip,
} from 'carbon-components-react';
import { segmentTracking } from '../../../lib/tracker';
import './Landing.scss';
import PublicImage from 'src/common/components/PublicImage';
import { tileInfo } from 'src/apps/spss-purchase-advisor-self-assessment/constants/default';
import { segmentsTracking } from 'src/common/lib/tracker';
import { que2bValueProps } from '../../SPSSPurchaseAdvisorSelfAssessment';
import {
  convertToString,
  TranslationFunction,
} from 'src/common/hooks/widgets/useTranslation';

type LandingProps = {
  handleLaunchModal: () => void;
  openLanding: boolean;
  setOpenLanding: React.Dispatch<React.SetStateAction<boolean>>;
  setTile: React.Dispatch<React.SetStateAction<string>>;
  tile: string;
  setPathSelected: React.Dispatch<React.SetStateAction<string>>;
  setQue1Value: React.Dispatch<React.SetStateAction<string>>;
  setQue2AValue: React.Dispatch<React.SetStateAction<string>>;
  setQue2BValue: React.Dispatch<React.SetStateAction<que2bValueProps>>;
  setStatsPkg: React.Dispatch<React.SetStateAction<string>>;
  useTranslation: TranslationFunction;
};

export const Landing = ({
  handleLaunchModal,
  openLanding,
  setOpenLanding,
  setTile,
  tile,
  setPathSelected,
  setQue1Value,
  setQue2AValue,
  setQue2BValue,
  setStatsPkg,
  useTranslation,
}: LandingProps) => {
  const profIconImg = 'images/Professional1.svg';
  const reasearchIconImg = 'images/Researcher1.svg';
  const studentImg = 'images/Student.svg';
  const existUserImg = 'images/Exististing user.svg';
  const teacherImg = 'images/Teacher 1.svg';
  const resetValue = () => {
    setQue1Value('');
    setQue2AValue('');
    setStatsPkg('');
    setQue2BValue({
      options: {
        Q3BA1: {
          value: '',
          checked: false,
        },
        Q3BA2: {
          value: '',
          checked: false,
        },
        Q3BA3: {
          value: '',
          checked: false,
        },
        Q3BA4: {
          value: '',
          checked: false,
        },
      },
    });
  };
  return (
    <div className="bx--grid">
      <div className="Landing">
        <Modal
          passiveModal={true}
          open={openLanding}
          size={'lg'}
          onRequestClose={() => {
            segmentTracking('CTA Clicked', {
              pageTitle: 'SPSS Purchasing Advisor Self Assessment',
              object: 'SPSS Purchasing Advisor Self Assessment page',
              resultValue: 'CTA clicked',
              CTA: 'Form modal closed on the corner',
              location: 'URX Form',
              action: `Form modal closed`,
              field: '',
            });
            setOpenLanding(false);
          }}
        >
          <ModalBody hasForm className="ModalBody">
            <div className="bx--row nam">
              {' '}
              <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                <div className="bx--row landingDiv1">
                  <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                    <div>
                      <p className="type1">{useTranslation('landingTitle')}</p>
                    </div>
                    <div className="mar-top-06">
                      <p className="type4">
                        {useTranslation('landingSubTitle')}
                      </p>
                    </div>
                    <div className="mar-top-08">
                      <p className="type5">{useTranslation('landingText1')}</p>
                    </div>
                  </div>
                </div>
                <div className="bx--row landingDiv1">
                  <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4 mar-top-06">
                    <TileGroup
                      className="tilegroup"
                      name="radio tile group"
                      valueSelected={tile}
                    >
                      <RadioTile
                        className="tile"
                        id="radio-tile-1-purchase-advisor"
                        value={tileInfo.tile1}
                        onClick={() => {
                          setPathSelected('Professional');
                          setTile(tileInfo.tile1);
                          resetValue();
                          handleLaunchModal();
                          segmentsTracking('CTA Clicked', {
                            pageTitle:
                              'SPSS Purchasing Advisor Self Assessment',
                            object:
                              'SPSS Purchasing Advisor Self Assessment page',
                            resultValue: 'CTA clicked',
                            CTA: 'Professional Tile',
                            location: 'Assessment Options',
                            action: '',
                            field: '',
                          });
                        }}
                      >
                        <PublicImage
                          imgPath={profIconImg}
                          widgetId="spss-purchase-advisor-self-assessment"
                          id="img2"
                          alt="SPSS Self Assessment icon picture"
                        />
                        <div>
                          <span className="type2Bold">
                            {useTranslation('tile_label1')}
                          </span>
                          <span className="type2">
                            {' '}
                            {useTranslation('tile_info1')}
                          </span>
                        </div>
                      </RadioTile>

                      <RadioTile
                        className="tile"
                        id="radio-tile-2-purchase-advisor"
                        value={tileInfo.tile2}
                        onClick={() => {
                          setPathSelected('Researcher/Independent User');
                          setTile(tileInfo.tile2);
                          handleLaunchModal();
                          resetValue();
                          segmentsTracking('CTA Clicked', {
                            pageTitle:
                              'SPSS Purchasing Advisor Self Assessment',
                            object:
                              'SPSS Purchasing Advisor Self Assessment page',
                            resultValue: 'CTA clicked',
                            CTA: 'Researcher/Independent Tile',
                            location: 'Assessment Options',
                            action: '',
                            field: '',
                          });
                        }}
                      >
                        <PublicImage
                          imgPath={reasearchIconImg}
                          widgetId="spss-purchase-advisor-self-assessment"
                          id="img2"
                          alt="SPSS Self Assessment Steps picture"
                        />
                        <div>
                          <span className="type2Bold">
                            {useTranslation('tile_label2')}
                          </span>
                          <span className="type2">
                            {' '}
                            {useTranslation('tile_info2')}
                          </span>
                        </div>
                      </RadioTile>

                      <RadioTile
                        className="tile"
                        id="radio-tile-3-purchase-advisor"
                        value={tileInfo.tile3}
                        onClick={() => {
                          setPathSelected('Student');
                          setTile(tileInfo.tile3);
                          handleLaunchModal();
                          resetValue();
                          segmentsTracking('CTA Clicked', {
                            pageTitle:
                              'SPSS Purchasing Advisor Self Assessment',
                            object:
                              'SPSS Purchasing Advisor Self Assessment page',
                            resultValue: 'CTA clicked',
                            CTA: 'Student Tile',
                            location: 'Assessment Options',
                            action: '',
                            field: '',
                          });
                        }}
                      >
                        <PublicImage
                          imgPath={studentImg}
                          widgetId="spss-purchase-advisor-self-assessment"
                          id="img2"
                          alt="SPSS Self Assessment Steps picture"
                        />

                        <div className="type2Bold">
                          {useTranslation('tile_label3')}
                        </div>
                      </RadioTile>
                      <RadioTile
                        className="tile"
                        id="radio-tile-4-purchase-advisor"
                        value={tileInfo.tile4}
                        onClick={() => {
                          setPathSelected('Educator');
                          setTile(tileInfo.tile4);
                          handleLaunchModal();
                          resetValue();
                          segmentsTracking('CTA Clicked', {
                            pageTitle:
                              'SPSS Purchasing Advisor Self Assessment',
                            object:
                              'SPSS Purchasing Advisor Self Assessment page',
                            resultValue: 'CTA clicked',
                            CTA: 'Educator Tile',
                            location: 'Assessment Options',
                            action: '',
                            field: '',
                          });
                        }}
                      >
                        <PublicImage
                          imgPath={teacherImg}
                          widgetId="spss-purchase-advisor-self-assessment"
                          id="img2"
                          alt="SPSS Self Assessment Steps picture"
                        />
                        <div>
                          <span className="type2Bold">
                            {useTranslation('tile_label4')}
                          </span>
                          <span className="type2">
                            {' '}
                            {useTranslation('tile_info4')}
                          </span>
                        </div>
                      </RadioTile>
                      <RadioTile
                        className="tile"
                        id="radio-tile-5-purchase-advisor"
                        value={tileInfo.tile5}
                        onClick={() => {
                          setPathSelected('Current User');
                          setTile(tileInfo.tile5);
                          handleLaunchModal();
                          resetValue();
                          segmentsTracking('CTA Clicked', {
                            pageTitle:
                              'SPSS Purchasing Advisor Self Assessment',
                            object:
                              'SPSS Purchasing Advisor Self Assessment page',
                            resultValue: 'CTA clicked',
                            CTA: 'Current User Tile',
                            location: 'Assessment Options',
                            action: '',
                            field: '',
                          });
                        }}
                      >
                        <PublicImage
                          imgPath={existUserImg}
                          widgetId="spss-purchase-advisor-self-assessment"
                          id="img2"
                          alt="SPSS Self Assessment Steps picture"
                        />
                        <div>
                          <span className="type2Bold">
                            {useTranslation('tile_label5')}
                          </span>
                          <span className="type2">
                            {' '}
                            {useTranslation('tile_info5')}
                          </span>
                        </div>
                      </RadioTile>
                    </TileGroup>
                  </div>
                </div>
                <div className="bx--row landingDiv1">
                  <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-5 mar-left">
                    <span className="type6">
                      {useTranslation('learn_about')}
                    </span>
                    <Tooltip
                      onChange={() => {
                        segmentsTracking('CTA Clicked', {
                          pageTitle: 'SPSS Purchasing Advisor Self Assessment',
                          object:
                            'SPSS Purchasing Advisor Self Assessment page',
                          resultValue: 'CTA clicked',
                          CTA: 'Learn about tooltip',
                          location: 'Assessment Options',
                          action: '',
                          field: '',
                        });
                      }}
                      className="spss_landing_tooltip tooltip-landing-mt1"
                      direction={'top'}
                      tabIndex={0}
                      triggerText={` ${convertToString(
                        useTranslation('landing_tooltip1_text', true),
                      )}`}
                      showIcon={false}
                    >
                      <div className="slide_text_bold">
                        {useTranslation('landing_tooltip1_label1')}
                      </div>
                      <span className="slide_text">
                        {useTranslation('landing_tooltip1_info1')}
                      </span>
                      <div className="margintop_1">
                        <div className="slide_text_bold">
                          {useTranslation('landing_tooltip1_label2')}
                        </div>
                        <span className="slide_text">
                          {useTranslation('landing_tooltip1_info2')}
                        </span>
                      </div>
                      <div className="margintop_1">
                        <div className="slide_text_bold">
                          {useTranslation('landing_tooltip1_label3')}
                        </div>
                        <span className="slide_text">
                          {useTranslation('landing_tooltip1_info3')}
                        </span>
                      </div>
                    </Tooltip>
                    <span className="type6"> & </span>
                    <Tooltip
                      onChange={() => {
                        segmentsTracking('CTA Clicked', {
                          pageTitle: 'SPSS Purchasing Advisor Self Assessment',
                          object:
                            'SPSS Purchasing Advisor Self Assessment page',
                          resultValue: 'CTA clicked',
                          CTA: 'User Types tooltip',
                          location: 'Estimator',
                          action: '',
                          field: '',
                        });
                      }}
                      className="spss_landing_tooltip tooltip-landing-mt2"
                      direction={'top'}
                      tabIndex={0}
                      triggerText={` ${convertToString(
                        useTranslation('landing_tooltip2_text', true),
                      )}`}
                      showIcon={false}
                    >
                      <div className="slide_text_bold">
                        {useTranslation('landing_tooltip2_label1')}
                      </div>
                      <span className="slide_text">
                        {useTranslation('landing_tooltip2_info1')}
                      </span>
                      <div className="margintop_1">
                        <div className="slide_text_bold">
                          {useTranslation('landing_tooltip2_label2')}
                        </div>
                        <span className="slide_text">
                          {useTranslation('landing_tooltip2_info2')}
                        </span>
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </div>
  );
};
